export function getdata() {
	var obj = {
		searchlist: [{
				prop: "cellCode",
				label: '项目代码',
				type: "input",
			},
			{
				prop: "cellName",
				label: '项目名称',
				type: "input",
			}
		],
		searchdata: {
			cellCode: "",
			cellName: ""
		},
		headData: [{
				title: "项目代码",
				prop: "cellCode",
				width: 130,
				issort: true,
			},
			{
				title: "项目名称",
				prop: "cellName",
				width: 160,
				issort: true,
			},
			{
				title: "本地值",
				prop: "localValue",
				width: 130,
				issort: true,
			},
			{
				title: "税局值",
				prop: "analysisValue",
				width: 130,
				issort: true,
			},
			// {
			// 	title: "差异",
			// 	prop: "diffValue",
			// 	width: 130,
			// 	AmountFormat: true,
			// 	custom: true
			// }
		],
		pagination: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		},
	}
	return obj
}
